import { serviceInstance } from 'libs';

export default {
  fetchSettlementLogs: (
    merchantId,
    startDate,
    endDate,
    paymentRef,
    page,
    limit,
    status,
  ) =>
    serviceInstance
      .get(
        `/settlements/merchants/${merchantId}?from=${startDate}&to=${endDate}${
          paymentRef !== '' ? `&reference=${paymentRef}` : ''
        }&page=${page}&limit=${limit}${
          status !== '' ? `&status=${status}` : ''
        }`,
      )
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  fetchAllBanks: () =>
    serviceInstance
      .get('/api/banks?page=1&size=500')
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  createBankAccount: (body, merchantId) =>
    serviceInstance
      .post(`/api/merchant/${merchantId}/bank`, body)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  fetchMerchantBanks: (merchantId) =>
    serviceInstance
      .get(`/api/merchant/${merchantId}/banks`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  fetchSettlementDetails: (settlementId, startDate, endDate, page, limit) =>
    serviceInstance
      .get(
        `/settlements/${settlementId}/breakdowns?from=${startDate}&to=${endDate}&page=${page}&limit=${limit}`,
      )
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  lookupAccount: (accountNumber, bankCode) =>
    serviceInstance
      .get(
        `/payments/bank-account-lookup?accountNumber=${accountNumber}&bankCode=${bankCode}`,
      )
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  fetchSettlementPeriods: () =>
    serviceInstance
      .get('/settings/settlement-period')
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  fetchSettlementTimes: () =>
    serviceInstance
      .get('/settings/settlement-time')
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  fetchSettlementTimesSetting: (merchantId) =>
    serviceInstance
      .get(`/settings/merchant/${merchantId}/settlement`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  createSettlementTimes: (body, merchantId) =>
    serviceInstance
      .post(`/settings/merchant/${merchantId}/settlement`, body)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  updatePrimaryAccount: (body) =>
    serviceInstance
      .put(`/api/merchant/banks/primary/update`, body)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  updateSettlementTimes: (body, merchantId) =>
    serviceInstance
      .put(`/settings/merchant/${merchantId}/settlement`, body)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  deleteAccount: (body) =>
    serviceInstance
      .delete(
        `/api/merchant/banks/${body.merchantId}/${body.bankAccountId}}/delete`,
      )
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
};
